import { arrayOf, string } from 'prop-types';

export const DEFAULT_BRAND_NAME = 'Brand Name';

export const BRIEF_DATA = {
    brandName: string,
    slogan: string,
    industries: arrayOf(string),
    keywords: arrayOf(string),
};
